var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.258 0.132353L7 6.70588L0.742 0.132353C0.658 0.0441177 0.555333 0 0.434 0C0.312667 0 0.21 0.0441177 0.126 0.132353C0.042 0.220588 0 0.328431 0 0.455883C0 0.583334 0.042 0.691177 0.126 0.779412L7 8L13.874 0.779412C13.958 0.691177 14 0.583334 14 0.455883C14 0.328431 13.958 0.220588 13.874 0.132353C13.79 0.0441177 13.6873 0 13.566 0C13.4447 0 13.342 0.0441177 13.258 0.132353Z",
    fill: "#415385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.258 5.13235L7 11.7059L0.742 5.13235C0.658 5.04412 0.555333 5 0.434 5C0.312667 5 0.21 5.04412 0.126 5.13235C0.042 5.22059 0 5.32843 0 5.45588C0 5.58333 0.042 5.69118 0.126 5.77941L7 13L13.874 5.77941C13.958 5.69118 14 5.58333 14 5.45588C14 5.32843 13.958 5.22059 13.874 5.13235C13.79 5.04412 13.6873 5 13.566 5C13.4447 5 13.342 5.04412 13.258 5.13235Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownTree);
export default __webpack_public_path__ + "static/media/dropdown-tree.b94f5f9c2f5c3d2272e7e0827383d0fe.svg";
export { ForwardRef as ReactComponent };